import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when Forgot Email request is successful.
 * @memberOf Playtech.API.events
 * @event FORGOT_EMAIL_SUCCESS
 * @type {callback}
 * @example Playtech.on('FORGOT_EMAIL_SUCCESS', () => { ... });
 */
export const EVENT_FORGOT_EMAIL_SUCCESS = 'FORGOT_EMAIL_SUCCESS';
/**
 * Event fires when Forgot Email request is failed.
 * @memberOf Playtech.API.events
 * @event FORGOT_EMAIL_FAIL
 * @type {callback}
 * @example Playtech.on('FORGOT_EMAIL_FAIL', () => { ... });
 */
export const EVENT_FORGOT_EMAIL_FAIL = 'FORGOT_EMAIL_FAIL';

export const useOnForgotEmail = (eventTarget: EventTarget) => {
    const onForgotEmailSuccess = useCallback((...args: any[]): void => {
        eventTarget.dispatchEvent(new CustomEvent(EVENT_FORGOT_EMAIL_SUCCESS, { detail: args }));
    }, [eventTarget]);

    const onForgotEmailFail = useCallback((...args: any[]): void => {
        eventTarget.dispatchEvent(new CustomEvent(EVENT_FORGOT_EMAIL_FAIL, { detail: args }));
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('forgotEmail:success', onForgotEmailSuccess);
        publicEventsAPIService.on('forgotEmail:fail', onForgotEmailFail);

        return () => {
            publicEventsAPIService.off('forgotEmail:success', onForgotEmailSuccess);
            publicEventsAPIService.off('forgotEmail:fail', onForgotEmailFail);
        };
    }, [onForgotEmailSuccess, onForgotEmailFail]);
};
